import { useBoundStore } from '../store'
import { getEffectiveThemeMode } from '../store/theme'
import { TOKENS, TokenName, ThemeMode } from '../theme/tokens'

// Resolved hex tokens for the EFFECTIVE theme (preference gated by scope).
// For renderers that cannot read CSS custom properties — canvas charts
// (react-force-graph-2d, d3 canvas), @mui/x-charts series colors, exports.
// DOM/SVG-style consumers should keep using var(--*) strings instead.
export function useThemeTokens(): {
  mode: ThemeMode
  tokens: Record<TokenName, string>
} {
  const mode = useBoundStore(getEffectiveThemeMode)
  return { mode, tokens: TOKENS[mode] }
}
